// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "logo-wrs5C";
var _5 = "button-Oq8d8";
var _6 = "popup-1bGjw";
var _7 = "stepbar__actions-3q8pj";
var _8 = "stepbar__action-1oKpQ";
var _9 = "stepbar__action_close-278xZ stepbar__action-1oKpQ";
var _a = "stepbar__action_openPolicy-2LFCI stepbar__action-1oKpQ";
var _b = "popup__title-3tGqD";
var _c = "popup__text-1ga_B";
var _d = "popup__buttons-31N_m";
var _e = "slide__content-3u6ME";
var _f = "paper-3m2uR";
var _10 = "paper_confirm-2Kv2o";
var _11 = "paper_download-3YU2R";
var _12 = "scrollBody-1dN_c";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "logo", _5 as "button", _6 as "popup", _7 as "stepbar__actions", _8 as "stepbar__action", _9 as "stepbar__action_close", _a as "stepbar__action_openPolicy", _b as "popup__title", _c as "popup__text", _d as "popup__buttons", _e as "slide__content", _f as "paper", _10 as "paper_confirm", _11 as "paper_download", _12 as "scrollBody" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "logo": _4, "button": _5, "popup": _6, "stepbar__actions": _7, "stepbar__action": _8, "stepbar__action_close": _9, "stepbar__action_openPolicy": _a, "popup__title": _b, "popup__text": _c, "popup__buttons": _d, "slide__content": _e, "paper": _f, "paper_confirm": _10, "paper_download": _11, "scrollBody": _12 }
